module.exports = __webpack_public_path__ + "static/media/logo-big.33aea5ed.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/logo-big.png
 ** module id = 591
 ** module chunks = 0
 **/